var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-post"},[_c('div',{staticClass:"text"},[_c('h2',[_vm._v(_vm._s(_vm.post.name))]),_c('i',[_vm._v(_vm._s(_vm.post.created_at))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.post.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }